import * as Dialog from '@radix-ui/react-dialog';
import { forwardRef } from 'react';

export const ModalDialogClose = forwardRef<
  HTMLButtonElement,
  Dialog.DialogCloseProps
>(({ children, ...props }, ref) => {
  return (
    <Dialog.Close {...props} ref={ref} asChild>
      {children}
    </Dialog.Close>
  );
});

ModalDialogClose.displayName = 'ModalDialog.Close';
